import Teamdrop from "../component/team"
import Doctor from "../component/doctor"
function TeamDrop(){
    return(
        <>
        <Teamdrop/>
        <Doctor/>
        </>
    )
}
export default TeamDrop